import { Item } from '../../common/snippets'
import { AcountingHeading } from './common/AcountingHeading'
import { Box, Button } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { useEffect, useState } from 'react'
import moment from 'moment'
import { floatFilter, focusElemnt, isEmpty, navigation1 } from '../../common/helper'
import useToken from '../../helpers/useTokens'
import { TableComponent } from '../../common/TableComponent'
import { BranchDueDetailedHeaders, BranchDueHeaders, criteriaHeaders } from './contants'
import LineinputV2 from '../../common/lineinputV2'
import { GetRequest, PostRequest } from '../../common/api'
import { reportViewDispatchFilter, urls } from '../../common/constants'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { accumulateTotals } from '../Reports/NonMovementTable/utilFucntions'
import { groupData } from '../Reports/userWiseCollReport/utilFucntions'
import { formatDate, normalizeDate } from '../../common/dateHelpers'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'
const reportNameSummmary = 'Branch Due Report'
const reportNameDetailed = 'Branch Due Detailed Report'
export const BranchDueReport = () => {
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const { loginData } = useToken()
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }
  const { IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
  const [disableBtn, setDisableBtn] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [stateList, setStateList] = useState([])
  const [filterdStateList, setFilterdStateList] = useState([])
  const [selState, setSelState] = useState()
  const [cityList, setCityList] = useState([])
  const [filterdCityList, setFilterdCityList] = useState([])
  const [selCity, setSelCity] = useState()
  const [branchList, setBranchList] = useState([])
  const [filterdBranchList, setFilterdBranchList] = useState([])
  const [selBranch, setSelBranch] = useState()
  const [tableData, setTableData] = useState([])
  const [reportView, setReportView] = useState(reportViewDispatchFilter[0])
  const reportName = reportView.id === 0 ? reportNameSummmary : reportNameDetailed
  const isAnyAdmin = IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const headers = BranchDueHeaders.filter((col) => {
    if (IsMTPLAdmin === 0 && IsAdmin === 0) {
      return col.field !== 'edit_view'
    }
    return true
  }).map((col) => ({
    ...col,
    align: col.align || (col.xlCol?.dataType === 'quantity' ? 'right' : 'left'),
    exportHead: col.header,
  }))
  const detailedHeaders = BranchDueDetailedHeaders.map((col) => ({
    ...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.header,
  }))
  useEffect(() => {
    if (!isEmpty(cargoRoleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
    }
  }, [cargoRoleRights, loginData])
  const fetchFilters = () => {
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
    }
    GetRequest(urls.getBranchDueReportFilterData, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }

        const raw = res.Data.Table

        // ================= STATE LIST =================
        let states = [
          ...new Map(raw.map((r) => [Number(r.StateID), { StateID: Number(r.StateID), StateName: r.StateName.trim() }])).values(),
        ]

        if (states.length > 1 && isAnyAdmin) {
          states.unshift({ StateID: 0, StateName: 'All' })
        }

        setStateList(states)
        setFilterdStateList(states)

        // ================= CITY LIST =================
        let cities = [
          ...new Map(
            raw.map((r) => [
              Number(r.CityID),
              {
                StateID: Number(r.StateID),
                CityID: Number(r.CityID),
                CityName: r.CityName.trim(),
              },
            ])
          ).values(),
        ]

        setCityList(cities)

        // ================= BRANCH LIST =================
        let branches = [
          ...new Map(
            raw.map((r) => [
              Number(r.BranchID),
              {
                StateID: Number(r.StateID),
                CityID: Number(r.CityID),
                BranchID: Number(r.BranchID),
                BranchName: r.BranchName.trim(),
              },
            ])
          ).values(),
        ]

        setBranchList(branches)

        // ===================================================
        // 🔥 LOGIN BASED AUTO SELECTION USING intBranchID
        // ===================================================

        const loginBranchID = Number(loginData.intBranchID)

        const loginBranchData = raw.find((r) => Number(r.BranchID) === loginBranchID)

        if (!loginBranchData && !disableBtn) {
          // fallback: select All
          setFilterdCityList(cities)
          setFilterdBranchList(branches)
          setSelState(states[0])
          setSelCity(cities[0])
          setSelBranch(branches[0])
          return
        }
        if (!loginBranchData && disableBtn) {
          throw new Error('No Data Found')
        }

        const loginCityID = Number(loginBranchData.CityID)
        const loginStateID = Number(loginBranchData.StateID)

        // ================= SELECT STATE =================
        const selectedState = reportView.id === 1 || disableBtn ? states.find((s) => s.StateID === loginStateID) || states[0] : states[0]

        // ================= FILTER CITIES =================
        let stateCities = selectedState.StateID === 0 ? cities : cities.filter((c) => c.StateID === selectedState.StateID)

        if (stateCities.length > 1 && (selectedState.StateID !== 0 || reportView.id === 0) && isAnyAdmin) {
          stateCities = [{ CityID: 0, CityName: 'All' }, ...stateCities]
        }

        const selectedCity = reportView.id === 1|| disableBtn ? stateCities.find((c) => c.CityID === loginCityID) || stateCities[0] : stateCities[0]

        // ================= FILTER BRANCHES =================
        let cityBranches =
          selectedCity.CityID === 0
            ? branches.filter((b) => selectedState.StateID === 0 || b.StateID === selectedState.StateID)
            : branches.filter((b) => b.CityID === selectedCity.CityID)

        if (cityBranches.length > 1 && (selectedCity.CityID !== 0 || selectedState.StateID !== 0 || reportView.id === 0) && isAnyAdmin) {
          cityBranches = [{ BranchID: 0, BranchName: 'All' }, ...cityBranches]
        }

        const selectedBranch =
          reportView.id === 1 || disableBtn ? cityBranches.find((b) => b.BranchID === loginBranchID) || cityBranches[0] : cityBranches[0]

        // ================= SET STATE =================
        setFilterdCityList(stateCities)
        setFilterdBranchList(cityBranches)

        setSelState(selectedState)
        setSelCity(selectedCity)
        setSelBranch(selectedBranch)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleChange = (e, id, key, list) => {
    const newList = list.map((col, i) => (i === id ? { ...col, [key]: +e || 0 } : col))
    setTableData(handleInputs(newList))
  }
  const fetchTableData = () => {
    if (!selState?.StateName || !selCity?.CityName || !selBranch?.BranchName) {
      setAlert({ show: true, msg: 'Please select state, city and branch', nextId: '' })
      return
    }
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
      StateID: selState?.StateID || 0,
      CityID: selCity?.CityID || 0,
      BranchID: selBranch?.BranchID || 0,
    }
    const url = reportView.id === 0 ? urls.getBranchDueReportData : urls.getBranchDueReportDetailedData
    GetRequest(url, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const data = reportView.id === 0 ? formatTableData(res.Data.Table) : formatTableDataDetailed(res.Data, detailedHeaders)
        setTableData(data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const formatTableData = (list) => {
    list = list.map((col, index) => ({
      ...col,
      dataType: 'entry',
      SN: index + 1,
      disabled: true,
      TransDate: moment(col.TransDate).format('DD-MM-YYYY'),
    }))
    const grouped = list.reduce((map, curr) => {
      const key = curr.TransDate

      if (!map.has(key)) {
        map.set(key, [])
      }

      map.get(key).push(curr)

      return map
    }, new Map())
    const numericKeys = BranchDueHeaders.reduce((acc, curr) => {
      if (curr.xlCol.dataType === 'quantity') {
        acc.push(curr.field?.replace(/_view$/, ''))
      }
      return acc
    }, [])
    const formatted = Array.from(grouped.entries()).flatMap(([transDate, items]) => {
      const groupTotal = accumulateTotals(items, numericKeys)
      const groupTotal_vew = Object.fromEntries(Object.entries(groupTotal).map(([key, value]) => [`${key}_view`, value]))
      return [
        ...items,
        {
          dataType: 'total',
          [BranchDueHeaders[0].field]: `TOTAL: ${transDate}`,
          align: { [BranchDueHeaders[0].field]: 'right' },
          colSpan: { [BranchDueHeaders[0].field]: 5 },
          ...groupTotal,
          ...groupTotal_vew,
        },
      ]
    })
    const data = handleInputs(formatted)
    return data
  }
  const formatTableDataDetailed = (data, headers) => {
    const lengths = [4, headers.length - 5, 1]
    let index = 0
    const pickedHeaders = []
    lengths.forEach((span) => {
      pickedHeaders.push(headers[index].field)
      index += span
    })
    const mainList = data.Table.map((a) => ({
      ...a,
      dataType: 'entry',
      TransDateDay: normalizeDate(a.TransDate),
      TransDateView: formatDate(normalizeDate(a.TransDate)),
    }))
    const grouped = groupData('TransDateDay', mainList)
    const sortedData = Object.entries(grouped)
      .sort(([dateA], [dateB]) => Number(dateA) - Number(dateB))
      .map(([, values]) => values)
    const result = []
    const dayBeforeFromDate = fromDate.clone().subtract(1, 'day')
    const balance = data.Table1.find((a) => formatDate(normalizeDate(a.TranDate)) === dayBeforeFromDate.format('DD-MM-YYYY')) || {
      OpeningBalance: 0,
      ClosingBalance: 0,
    }
    result.push({
      dataType: 'subHeader',
      [pickedHeaders[0]]: `OUTSTANDING BALANCE :  ${formatDate(dayBeforeFromDate)}`,
      [pickedHeaders[1]]: `(Previous Outstanding + Paid Collection + ToPay Delivery - Booking Comm. - Delivery Comm. + TDS - Payment Received-Other Expenses Indented) = Current Outstanding`,
      [headers[headers.length - 1].field]: balance.ClosingBalance,
      align: { [pickedHeaders[0]]: 'right', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
      colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    })
    sortedData.forEach((item) => {
      const date = item[0].TransDateDay
      result.push(...item)

      const numericKeys = BranchDueDetailedHeaders.reduce((acc, curr) => {
        if (curr.xlCol.dataType === 'quantity') {
          acc.push(curr.field?.replace(/_view$/, ''))
        }
        return acc
      }, [])
      const groupTotal = accumulateTotals(item, numericKeys)
      result.push({
        dataType: 'total',
        [pickedHeaders[0]]: `TOTAL`,
        align: { [pickedHeaders[0]]: 'right' },
        colSpan: { [pickedHeaders[0]]: 7 },
        ...groupTotal,
      })
      const amountReceived = data.Table2.find((a) => normalizeDate(a.TranDate) === date) || { Rechargeamount: 0 }
      const indentAmount = data.Table3.find((a) => normalizeDate(a.TranDate) === date) || { ExpenseAmount: 0 }
      result.push({
        dataType: 'total',
        [pickedHeaders[0]]: `Less: Amount Received`,
        align: { [pickedHeaders[0]]: 'right' },
        colSpan: { [pickedHeaders[0]]: headers.length - 1 },
        [pickedHeaders[2]]: amountReceived.Rechargeamount,
      })
      result.push({
        dataType: 'total',
        [pickedHeaders[0]]: `Less: Indent Approved (Cartages + Hire + Others)`,
        align: { [pickedHeaders[0]]: 'right' },
        colSpan: { [pickedHeaders[0]]: headers.length - 1 },
        [pickedHeaders[2]]: indentAmount.ExpenseAmount,
      })
      const balance = data.Table1.find((a) => normalizeDate(a.TranDate) === date) || { OpeningBalance: 0, ClosingBalance: 0 }
      result.push({
        dataType: 'subHeader',
        [pickedHeaders[0]]: `OUTSTANDING BALANCE :  ${formatDate(date)}`,
        [pickedHeaders[1]]: `(Previous Outstanding + Paid Collection + ToPay Delivery - Booking Comm. - Delivery Comm. + TDS - Payment Received-Other Expenses Indented) = Current Outstanding`,
        [headers[headers.length - 1].field]: balance.ClosingBalance,
        align: { [pickedHeaders[0]]: 'right', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
      })
    })
    return result
  }
  const handleEdit = (e, index, disabled, list) => {
    e.preventDefault()
    e.stopPropagation()
    const newList = list.map((col, i) => (i === index ? { ...col, disabled: disabled } : col))
    if (disabled) {
      const item = newList[index]
      const data = { CompanyID: loginData.intCompanyID, BranchID: item.BranchID, ID: item.ID, Commission: item.Commission }
      setLoader(true)
      PostRequest(urls.branchDueAmountUpdate, data)
        .then((res) => {
          if (res.status !== 'Success') {
            throw new Error(res?.ErrMessage || 'Request Failed')
          }
          fetchTableData()
        })
        .catch((err) => {
          setAlert({ show: true, msg: err.message, nextId: '' })
        })
        .finally(() => setLoader(false))
    } else {
      setTableData(handleInputs(newList))
    }
  }

  const handleInputs = (list) => {
    return list.map((col, index) =>
      col.dataType === 'entry'
        ? {
            ...col,
            Commission_view: (
              <LineinputV2
                key={index}
                filter={floatFilter}
                onBlur={(e) => handleChange(e.target.value, index, 'Commission', list)}
                name="Commission"
                disabled={col.disabled}
                id={`Commission${index}`}
                value={col.Commission}
                onKeyDown={(e) =>
                  setTimeout(() => {
                    navigation1(e, `editButton${index}`, ``)
                  }, 0)
                }
              />
            ),
            edit_view: (
              <Button
                id={`editButton${index}`}
                onClick={(e) => handleEdit(e, index, !col.disabled, list)}
                variant={col.disabled ? 'outlined' : 'contained'}
                color="secondary"
                style={{ height: '30px', ...sx.novp }}
              >
                {col.disabled ? 'Edit' : 'Save'}
              </Button>
            ),
          }
        : col
    )
  }
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY'),
    toDate: toDate.format('DD-MM-YYYY'),
    selState: selState?.StateName,
    selCity: selCity?.CityName,
    selBranch: selBranch?.BranchName,
    dataType: 'entry',
  }
  const handleStateChange = (val) => {
    setSelState(val)
    const stateCities = val.StateID === 0 ? cityList : cityList.filter((city) => city.StateID === val.StateID)
    if (stateCities.length > 1 && val.StateID !== 0 && isAnyAdmin) {
      stateCities.unshift({ CityName: 'All', CityID: 0 })
    }
    setFilterdCityList(stateCities)
    setSelCity(stateCities[0])
    const cityBranches =
      val.StateID === 0
        ? branchList
        : stateCities[0].CityID === 0
          ? branchList.filter((branch) => branch.StateID === val.StateID)
          : branchList.filter((branch) => branch.CityID === stateCities[0].CityID)
    if (cityBranches.length > 1 && val.StateID !== 0 && isAnyAdmin) {
      cityBranches.unshift({ BranchName: 'All', BranchID: 0 })
    }
    setFilterdBranchList(cityBranches)
    setSelBranch(cityBranches[0])
  }
  const handleCityChange = (val) => {
    setSelCity(val)

    const cityBranches =
      val.CityID === 0
        ? selState.StateID === 0
          ? branchList
          : branchList.filter((branch) => branch.StateID === selState.StateID)
        : branchList.filter((branch) => branch.CityID === val.CityID)
    if (cityBranches.length > 1 && (val.CityID !== 0 || selState.StateID !== 0) && isAnyAdmin) {
      cityBranches.unshift({ BranchName: 'All', BranchID: 0 })
    }
    setFilterdBranchList(cityBranches)
    setSelBranch(cityBranches[0])
  }
  const handleReportViewChange = (val) => {
    setReportView(val)
    setTableData([])
    // if (val.id === 0) {
    //   setFilterdStateList(stateList)
    //   setFilterdCityList(cityList)
    //   setFilterdBranchList(branchList)
    //   setSelState(stateList[0])
    //   setSelCity(cityList[0])
    //   setSelBranch(branchList[0])
    // } else {
    //   const stateListTemp = stateList.filter((state) => state.StateID !== 0)
    //   const cityListTemp = cityList.filter((city) => city.CityID !== 0)
    //   const branchListTemp = branchList.filter((branch) => branch.BranchID !== 0)
    //   setFilterdStateList(stateListTemp)
    //   setFilterdCityList(cityListTemp)
    //   setFilterdBranchList(branchListTemp)
    //   setSelState(stateListTemp[0])
    //   setSelCity(cityListTemp[0])
    //   setSelBranch(branchListTemp[0])
    // }
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <AcountingHeading reportName={reportName.slice(0, -7)} />
      <Box sx={sx.reportFlex}>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompany}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            minWidth="250px"
          />
        </Item>

        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            name={'from_date'}
            id={id.fromDate}
            value={fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="210px"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            name={'to_date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt('buttonGo')
            }}
            width="210px"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonGo"
            onClick={fetchFilters}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item>

        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.stateId}
            label={lb.selectState}
            data={filterdStateList}
            defaultvalue={selState?.StateName || ''}
            value={selState?.StateName || ''}
            idKey={`StateID`}
            dataKey={`StateName`}
            onSelect={handleStateChange}
            searchPlaceholder={`Search State`}
            width="200px"
            nextId={id.srcCity}
            prevId={'buttonGo'}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.srcCity}
            label={lb.selectCity}
            data={filterdCityList}
            defaultvalue={selCity?.CityName || ''}
            value={selCity?.CityName || ''}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={handleCityChange}
            searchPlaceholder={`Search City`}
            width="250px"
            nextId={id.selectBranches}
            prevId={id.stateId}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectBranches}
            label={lb.selectBranches}
            data={filterdBranchList}
            defaultvalue={selBranch?.BranchName || ''}
            value={selBranch?.BranchName || ''}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setSelBranch(val)
            }}
            searchPlaceholder={`Search Branches`}
            width="240px"
            nextId={'buttonLoad'}
            prevId={id.srcCity}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={'reportView'}
            nextId={'SplitBtn'}
            prevId={'SelectVehicleNo'}
            label={'Report View'}
            data={reportViewDispatchFilter}
            defaultvalue={reportView?.Name || reportViewDispatchFilter}
            idKey={`id`}
            dataKey={`Name`}
            onSelect={handleReportViewChange}
            width="200px"
            searchPlaceholder={`Search By Report Type`}
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonLoad"
            onClick={fetchTableData}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            Load
          </Button>
        </Item>
      </Box>
      {tableData.length ? (
        <TableComponent
          reportName={reportName}
          criteriaHeaders={criteriaHeaders}
          criteriaData={[criteriaData]}
          tableData={tableData}
          mainHeader={reportView.id === 0 ? headers : detailedHeaders}
        />
      ) : (
        <></>
      )}
    </Item>
  )
}
